<!--Error page starts-->
<section id="error">
  <div class="container-fluid">
    <div class="row auth-height full-height-vh">
      <div class="col-12 d-flex align-items-center justify-content-center">
        <div class="row">
          <div class="col-12 text-center">
            <img src="../../../../assets/img/dtroy/nopasstruck.JPG" alt="" class="img-fluid error-img mt-2" height="300" width="400">
            <h1 class="mt-4">¡Alto! Acceso denegado</h1>
            <div class="w-75 error-text mx-auto mt-4">
              <p>Ups... parece que no tienes permisos de estar aquí o no ingresaste una dirección correcta</p>
            </div>
            <a [routerLink]="['/pages/login']" class="btn btn-info my-2">Verificar sesión</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Error page ends-->
